<template>
  <TableLayout>
    <!-- 搜索表单 -->
    <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="120px" inline>
      <el-form-item label="优惠券编码" prop="couponCode">
        <el-input v-model="searchForm.couponCode" placeholder="请输入关键字" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="支付订单号" prop="paymentOrderNo">
        <el-input v-model="searchForm.orderNo" placeholder="请输入关键字" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="微信支付订单号" prop="wxOrderNo">
        <el-input v-model="searchForm.wxOrderNo" placeholder="请输入关键字" @keypress.enter.native="search"></el-input>
      </el-form-item>
      <el-form-item label="支付状态" prop="paymentStatus">
        <el-select v-model="searchForm.paymentStatus" placeholder="请选择优惠券状态">
          <el-option label="未支付" value="0"></el-option>
          <el-option label="已支付" value="1"></el-option>
          <el-option label="已过期" value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="支付类型" prop="paymentType">
        <el-select v-model="searchForm.paymentType" placeholder="请选择支付类型" clearable>
          <el-option label="优惠券购买" :value="0"></el-option>
          <el-option label="押金支付触发延期" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <section>
        <el-button type="primary" @click="search">搜索</el-button>
        <el-button @click="reset">重置</el-button>
      </section>
    </el-form>
    <!-- 表格和分页 -->
    <template v-slot:table-wrap>
      <ul class="toolbar">
        <li><el-button @click="deleteByIdInBatch" icon="el-icon-delete">删除</el-button></li>
      </ul>
      <el-table
        v-loading="isWorking.search"
        :data="tableData.list"
        stripe
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="id" label="" min-width="100px"></el-table-column>
        <el-table-column prop="couponCode" label="优惠券编码" min-width="100px"></el-table-column>
        <el-table-column prop="orderNo" label="支付订单号" min-width="100px"></el-table-column>
        <el-table-column prop="wxOrderNo" label="微信支付订单号" min-width="100px"></el-table-column>
        <el-table-column prop="paymentStatus" label="支付状态" min-width="100px">
          <template slot-scope="{row}">
            <el-tag :type="getPayStatusType(row.paymentStatus)" size="small">
              {{ getPayStatusText(row.paymentStatus) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column label="支付金额" min-width="100px">
          <template slot-scope="{row}">
            {{ row.paymentAmount }}元
          </template>
        </el-table-column>
        <el-table-column prop="paymentType" label="支付类型" min-width="100px">
          <template slot-scope="{row}">
            {{ Number(row.paymentType) === 0 ? '优惠券购买' : '押金支付触发延期' }}
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="120"
          fixed="right"
        >
          <template slot-scope="{row}">
            <el-button type="text" icon="el-icon-sell" v-show="row.paymentStatus === 0" @click="goPay(row.id)">手动支付</el-button>
            <el-button type="text" @click="deleteById(row)" icon="el-icon-delete">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination
        @size-change="handleSizeChange"
        @current-change="handlePageChange"
        :pagination="tableData.pagination"
      >
      </pagination>
    </template>
    <!-- 支付进度弹框 -->
    <el-dialog
      :visible.sync="paymentDialogVisible"
      top="20%"
      width="200px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false">
        <div class="progress-content">
          <i class="el-icon-loading"></i>
          <span style="margin-left: 5px;">正在支付中</span>
        </div>
    </el-dialog>
  </TableLayout>
</template>

<script>
import BaseTable from '@/components/base/BaseTable'
import TableLayout from '@/layouts/TableLayout'
import Pagination from '@/components/common/Pagination'
import { manualUse } from '../../api/rentHouse/couponUseRecord'

export default {
  name: 'CouponList',
  extends: BaseTable,
  components: { TableLayout, Pagination },
  data () {
    return {
      // 搜索
      searchForm: {
        couponCode: null,
        orderNo: null,
        wxOrderNo: null,
        paymentStatus: null,
        paymentType: null,
        paymentAmount: null,
        paymentInitTime: null,
        delFlag: null
      },
      // 支付弹框状态
      paymentDialogVisible: false
    }
  },
  created () {
    this.config({
      module: '',
      api: '/rentHouse/couponUseRecord',
      'field.id': 'id',
      'field.main': 'id'
    })
    this.search()
  },
  methods: {
    getPayStatusText (status) {
      const statusMap = {
        0: '未支付',
        1: '已支付',
        2: '已过期'
      }
      return statusMap[status]
    },
    // 获取支付状态标签类型
    getPayStatusType (status) {
      const typeMap = {
        0: 'warning', // 未支付 - 橙色
        1: 'success', // 已支付 - 绿色
        2: 'danger' // 已过期 - 红色
      }
      return typeMap[status]
    },
    // 手动核销
    async goPay (id) {
      this.$confirm('确定手动支付吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        // 显示支付进度弹框
        this.paymentDialogVisible = true
        try {
          await manualUse(id)
          // 支付成功，关闭弹框并刷新数据
          this.paymentDialogVisible = false
          this.$message({
            message: '支付成功',
            type: 'success'
          })
          this.search()
        } catch (error) {
          // 支付失败
          this.paymentDialogVisible = false
          this.$message.error('支付失败，请重试')
          console.error('手动支付失败:', error)
        }
      }).catch(() => {
        // 用户取消操作
      })
    }
  }
}
</script>
<style scoped>
  .el-select-dropdown__item{
    height: auto !important;
  }
  .progress-content {
    text-align: center;
  }
  /deep/ .el-dialog__header {
    padding: 0 !important;
  }
</style>
